<div class="max-w-md mx-auto bg-white border border-gray-200 rounded-xl shadow-sm p-6">

  <h2 class="text-lg font-semibold text-gray-800 mb-5">
    RevoluPay Information
  </h2>

  <!-- Loader when data is loading -->
  <div *ngIf="!submitted" class="flex justify-center items-center py-10">
    <svg class="animate-spin h-8 w-8 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
    </svg>
  </div>

  <!-- User info when submitted is true -->
  <div class="divide-y divide-gray-100" *ngIf="submitted">

    <!-- RevoluPay User ID -->
    <div class="flex items-center justify-between py-3">
      <span class="text-sm text-gray-500">RevoluPay User ID</span>
      <span class="text-sm font-semibold text-gray-900">
        {{ userInfo?.revolupay_user_id || 'Unavailable' }}
      </span>
    </div>

    <!-- KYC Status -->
    <div class="flex items-center justify-between py-3">
      <span class="text-sm text-gray-500">KYC Status</span>
      <span class="px-2.5 py-1 text-xs font-medium rounded-full"
            [ngClass]="userInfo?.can_send_transaction ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'">
        {{ userInfo?.can_send_transaction ? 'Validated' : 'Not Validated' }}
      </span>
    </div>

    <!-- Remittances Access -->
    <div class="flex items-center justify-between py-3">
      <span class="text-sm text-gray-500">Remittances Access</span>

      <!-- Enabled badge -->
      <ng-container *ngIf="userInfo?.can_send_transaction; else disabledAccess">
        <span class="px-2.5 py-1 text-xs font-medium rounded-full bg-green-100 text-green-700">
          Enabled
        </span>
      </ng-container>

      <!-- Disabled badge + optional button -->
      <ng-template #disabledAccess>
        <div class="flex items-center gap-2">

          <!-- Disabled badge -->
          <span class="px-2.5 py-1 text-xs font-medium rounded-full bg-red-100 text-red-700">
            Disabled
          </span>

          <!-- Add Access Button -->
          <button *ngIf="!userInfo?.exists"
                  (click)="addAccess()"
                  [disabled]="addingAccess"
                  class="px-3 py-1.5 text-sm font-medium bg-blue-600 text-white rounded hover:bg-blue-700 transition flex items-center gap-2">

            <!-- Spinner inside button -->
            <svg *ngIf="addingAccess" class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
            </svg>

            <span>{{ addingAccess ? 'Adding...' : 'Add Access' }}</span>
          </button>

        </div>
      </ng-template>

    </div>

  </div>

</div>
